import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export default function GuestGate({ feature }) {
  return (
    <div data-testid="guest-gate" className="max-w-2xl mx-auto mt-8 rounded-2xl border border-amber-500/25 bg-amber-500/[0.05] p-8 text-center">
      <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.28em] text-amber-400 mb-3">
        <Sparkles className="h-3 w-3" /> Guest mode
      </div>
      <h2 className="text-base md:text-lg font-semibold text-zinc-50">
        Create your free account to {feature}.
      </h2>
      <p className="mt-2 text-sm text-zinc-400 leading-relaxed max-w-md mx-auto">
        As a guest you can experience sample interviews. A free account unlocks your own resume,
        your own job description, and your personal Interview Readiness Score.
      </p>
      <div className="mt-5 flex flex-wrap justify-center gap-3">
        <Link to="/register" data-testid="guest-gate-signup"
              className="inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold px-6 py-3 text-sm transition-colors">
          Create Free Account <ArrowRight className="h-4 w-4" />
        </Link>
        <Link to="/try" data-testid="guest-gate-sample"
              className="inline-flex items-center rounded-full border border-zinc-800 bg-zinc-900 hover:bg-zinc-800 text-zinc-200 px-6 py-3 text-sm transition-colors">
          Try a Sample Interview
        </Link>
      </div>
    </div>
  );
}
